/**
 * Normalize userrights from API / user profile (object keyed by module id or array).
 */
function normalizeUserRights(userrights) {
  if (userrights == null || userrights === '') {
    return [];
  }

  if (typeof userrights === 'string') {
    try {
      userrights = JSON.parse(userrights);
    } catch (e) {
      return [];
    }
  }

  if (Array.isArray(userrights)) {
    return userrights.filter((r) => r && typeof r === 'object');
  }

  if (typeof userrights === 'object') {
    return Object.values(userrights).filter((r) => r && typeof r === 'object');
  }

  return [];
}

function getRightsList(user) {
  let list = normalizeUserRights(user && user.userrights);

  if (!list.length) {
    try {
      const stored = JSON.parse(localStorage.getItem('UserRights') || '[]');
      list = normalizeUserRights(stored);
    } catch (e) {
      list = [];
    }
  }

  return list;
}

function isTruthyRight(value) {
  return value == 1 || value === true || value === '1';
}

function moduleMatches(record, moduleName) {
  if (!record || !moduleName) {
    return false;
  }
  const target = String(moduleName).toLowerCase();
  const candidates = [
    record.modulename,
    record.module,
    record.name,
  ];
  return candidates.some((c) => c != null && String(c).toLowerCase() === target);
}

export function hasRight(user, moduleName, rightName) {
  if (!user) {
    try {
      user = JSON.parse(localStorage.getItem('userData') || '{}');
    } catch (e) {
      user = {};
    }
  }

  const role = String(user.role || '').toLowerCase();
  const type = String(user.type || '').toLowerCase();
  if (role === 'admin' || type === 'admin') {
    return true;
  }

  const rights = getRightsList(user);

  // Legacy: no rights configured on user and nothing in UserRights - allow (unchanged behaviour).
  if (!rights.length && (user.userrights == null || user.userrights === '')) {
    return true;
  }

  if (!rights.length) {
    return false;
  }

  const moduleRight = rights.find((r) => moduleMatches(r, moduleName));
  if (moduleRight && isTruthyRight(moduleRight[rightName])) {
    return true;
  }

  return false;
}

/** CRM dashboard widgets: Lead module access or legacy dashboard module view. */
export function canViewCrmDashboardData(user) {
  if (hasRight(user, 'dashboard', 'view')) {
    return true;
  }
  const leadRights = ['view', 'add', 'edit', 'delete', 'self_data', 'self_child_data', 'all_data'];
  return leadRights.some((r) => hasRight(user, 'Lead', r) || hasRight(user, 'lead', r));
}
